import React, { useEffect, useRef } from 'react';
import { MoThemeProvider } from './mo-gel';
import { BreakingTheIce } from './themes/BreakingTheIce.theme';
import { Routes, Route, useLocation } from 'react-router-dom';
import { MainLayout } from './components/Layout/MainLayout';
import { appRoutes } from './routes';
import MixPanel from './services/MixPanel';
import DataLayer from './services/DataLayer';

const App: React.FC = () => {
  const location = useLocation();
  const lastTrackedRouteRef = useRef<string>('');

  useEffect(() => {
    window.dataLayer = window.dataLayer || [];
    MixPanel.init();
  }, []);

  useEffect(() => {
    const routeKey = `${location.pathname}${location.search}${location.hash}`;
    if (lastTrackedRouteRef.current === routeKey) {
      return;
    }
    lastTrackedRouteRef.current = routeKey;
    DataLayer.pushRouteChange();
  }, [location]);

  return (
    <MoThemeProvider theme={BreakingTheIce}>
      <MainLayout>
        <Routes>
          {appRoutes.map((route) => (
            <Route key={route.path} path={route.path} element={route.element} />
          ))}
        </Routes>
      </MainLayout>
    </MoThemeProvider>
  );
};

export default App;
